export const productRatesTranslationEn = {
    title: "Rates",
    singular: "Rate",
    fields: {
        price: "Price",
        date: "From date",
    },
};
